// src/react-query-client.js or a similar file
import { QueryClient } from 'react-query';

export const queryClient = new QueryClient();
